import React, {useEffect, useState} from 'react';
import { MapContainer, TileLayer, Popup, Polyline, Marker} from 'react-leaflet';
import L from 'leaflet';
import ClipLoader from 'react-spinners/ClipLoader';


function SelectedZones({StartingPoint, DestinationPoint}) {
    const [zones, setzones] = useState([]);
    const [popupData, setpopupData] = useState("");
    const [loading, setLoading] = useState(false); // Track loading state

    let url = `/api/roadtransport/zones_movement/?origin=${StartingPoint[0]}&destinations=${DestinationPoint}`

      useEffect(() => {
        setLoading(true); // Start loading

        fetch(url).then((res) =>
           res.json().then((res) => {
          
            console.log("Data",res.data)
            const reversedPointsArray = res.data.Coordinates.map(points =>
              points.map(point => [point[1], point[0]])
            );
            setzones(reversedPointsArray)
            setpopupData(res.data["ΕΜΗΚ"])
            setLoading(false); // Stop loading once data is fetched
            
          })
        )
        .catch((error) => {
          console.log("Refetching data for Zones!")
        });
      }, [url]);


      const defaultIcon = L.icon({
        iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41],
      });

      const center = [39.0742, 21.8243];
      const zoom = 7;
      

        if(!loading) {
          return (
            <div className = "container" style = {{marginBottom: "5%"}}>
              <p style = {{color: "orange"}}>*Για περισσότερες πληροφορίες πατήστε πάνω στην πινέζα.</p>
              <MapContainer
              center={center}
              zoom={zoom}
              //SOS It MUST HAVE STATIC HEIGHT IN ORDER TO SHOW
              style={{ height: "600px", width: "100%" }}
              >
                  <TileLayer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  />

                {zones.map((points, index) => {
                  const firstPoint = points[0];
                  const lastPoint = points[points.length - 1];
                  return (
                    <div key={index}>
                        <Marker position={firstPoint} icon = {defaultIcon}>
                        <Popup>
                          {StartingPoint[0]}
                        </Popup>
                      </Marker>
                      <Marker position={lastPoint} icon = {defaultIcon}>
                        <Popup>
                          {DestinationPoint[index]}
                        </Popup>
                      </Marker>
                      <Polyline pathOptions={{ weight: 5 }} positions={points} color="blue" > 
                        <Popup>
                            <div>
                              <p>Προέλευση: {StartingPoint[0]}</p>
                              <p>Προορισμός: {DestinationPoint}</p>
                              <p><strong>ΕΜΗΚ: {popupData}</strong></p>
                            </div>
                        </Popup>
                      </Polyline>
                    </div>
                  )
                })}
              
              </MapContainer>
            </div>
        );
      }
      else {
        return(
          <div className="container" style = {{marginLeft: "40%"}}>
            <ClipLoader size={100} color={'#123abc'} loading={true}/>
          </div>
        ) 
      }

    }



export default SelectedZones;